<template>
  <div id="cContentdetials" ref="Contentdetials">
    <div id="cNav">
      <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
        :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{ $route.query.collectionname }}
    </div>
    <div>
      <div>
        <div><img :src="tableData.collectionimages"></div>
      </div>
      <div>
        <div>{{ tableData.collectionname }}</div>
        <div>{{ tableData.collectiondescribe }}</div>
      </div>
    </div>
    <div style="clear: both;"></div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        clientHeight: '',
        collectionid: '',
        tableData: []
      }
    },
    mounted() {
      this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`;
      };
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    watch: {
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    methods: {
      changeFixed(clientHeight) { //动态修改样式
        this.$refs.Contentdetials.style.height = (clientHeight - 188) + 'px';
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        this.HOST = 'http://www.qhmuseum.cn/qhm-webapi';
        let url = this.HOST + '/collection/getdetials';
        this.collectionid = this.$route.query.collectionid;
        that.loading = true;
        let para = {
          collectionid: this.collectionid
        }
        this.$axios.post(url, qs.stringify(para)).then(function(result) {
          let cData = result.data;
          if (cData && cData.data) {
            that.tableData = cData.data;
            console.log(that.tableData.collectionimages)
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #cContentdetials {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }

  #cContentdetials>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #cContentdetials>#cNav>span:nth-child(1),
  #cContentdetials>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #cContentdetials>#cNav>span:nth-child(1):hover,
  #cContentdetials>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #cContentdetials>div:nth-child(2) {
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-align: start;
    -webkit-box-pack: start;
  }

  #cContentdetials>div:nth-child(2)>div:nth-child(1) {
    width: 30%;
    height: 400px;
    margin: 2%;

  }

  #cContentdetials>div:nth-child(2)>div:nth-child(1)>div {
    width: 300px;
    height: 400px;
    background-size: 300px 400px;
  }

  #cContentdetials>div:nth-child(2)>div:nth-child(2) {
    width: 60%;
    height: 400px;
    margin: 2%;
    link-height: 400px
  }

  #cContentdetials>div:nth-child(2)>div:nth-child(2)>div:nth-child(1) {
    text-align: left;
    padding: 20px;
    font-weight: bold;
  }

  #cContentdetials>div:nth-child(2)>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    padding: 20px;
    line-height: 30px;
  }

  #cContentdetials>div:nth-child(2) {
    background: url(../assets/img/detialback.png);
  }
</style>



// WEBPACK FOOTER //
// src/pages/CulturalDetials.vue